module.exports = __webpack_public_path__ + "img/20200502-1.122b945b.png";